import React from 'react';
import API from '../../api/api';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';
import '../../styles/css/users/userTable.css';
import DoneIcon from '@material-ui/icons/Done';
import TableRow from '@material-ui/core/TableRow';
// import Tooltip from '@material-ui/core/Tooltip';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
// import TableSortLabel from '@material-ui/core/TableSortLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

// let count = 0;
let counter = 0;
function createData(userId, name, userRole, email, ein, license_no, contactNo, status, address, state, zipcode) {
    counter += 1;
    return { id: counter, userId, userRole, name, email, ein, license_no, contactNo, status, address: { address, state, zipcode } };
}

// function desc(a, b, orderBy) {
//     if (b[orderBy] < a[orderBy]) {
//         return -1;
//     }
//     if (b[orderBy] > a[orderBy]) {
//         return 1;
//     }
//     return 0;
// }

// function getSorting(order, orderBy) {
//     return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
// }

const rows = [
    { id: 'userId', numeric: false, disablePadding: false, label: 'User ID' },
    { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
    { id: 'userRole', numeric: false, disablePadding: false, label: 'User role' },
    { id: 'email', numeric: false, disablePadding: false, label: 'Email' },
    { id: 'ein', numeric: false, disablePadding: false, label: 'EIN' },
    { id: 'licenseNo', numeric: false, disablePadding: false, label: 'License number' },
    { id: 'contactNo', numeric: false, disablePadding: false, label: 'Phone number' },
    { id: 'address', numeric: false, disablePadding: false, label: 'Address' },
    { id: 'actions', numeric: false, disablePadding: false, label: 'Actions' },
];

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{
                                    color: '#606060',
                                    paddingRight: '30px',
                                    textAlign: row.id === 'actions' && 'center',
                                }}
                            >
                                {row.label}
                                {/* <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                    </TableSortLabel>
                                </Tooltip> */}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    fixedTd: {
        width: '280px',
        borderBottom: '1px solid #d8d8d8'
    },
    cellWidth: {
        width: 'max-content',
        maxWidth: '300px',
        wordWrap: 'break-word',
    },
    cellMinWidth: {
        minWidth: '106px',
    },
    tdWidth: {
    },

});

class UsersPendingTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'userId',
            data: [],
            page: 0,
            rowsPerPage: 10,

            isAccepting: false,
            isRejecting: false,

            isTableLoading: true,
            buttonDisabled: false,
        };
    }

    componentDidMount() {
        API.get('user/all/2')
            .then(({ data }) => {
                this.setState({
                    data: data.response.map(
                        user => (
                            createData(
                                user.id,
                                user.name,
                                user.user_roles[0].name,
                                user.email,
                                user.ein,
                                user.license_no,
                                user.mobile_no,
                                user.status,
                                user.address,
                                user.state,
                                user.zipcode,
                            )
                        )
                    ),
                    isTableLoading: false,
                })
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            })
    }

    acceptUser = (userId) => {

        this.setState({
                isAccepting: true,
                buttonDisabled: true,
        })

        API.post('user/status/' + userId, { status: 1 })
            .then(res => {
                console.log("res", res);
                var prevData = this.state.data;
                prevData.forEach(e => {
                    if (e.userId === userId) {
                        var n = prevData.indexOf(e)
                        prevData.splice(n, 1)
                    }
                })
                this.setState({
                    isAccepting: false,
                    buttonDisabled: false,
                })
            })
            .catch((err) => {
                this.setState({
                    isAccepting: false,
                    buttonDisabled: false,
                })
                console.log("AXIOS ERROR: ", err);
            })
    }

    rejectUser = (userId) => {

        this.setState({
            isRejecting: true,
            buttonDisabled: true,
        })

        API.post('user/status/' + userId, { status: 3 })
            .then(res => {
                console.log("res", res);
                var prevData = this.state.data;
                prevData.forEach(e => {
                    if (e.userId === userId) {
                        var n = prevData.indexOf(e)
                        prevData.splice(n, 1)
                    }
                })
                this.setState({
                    isRejecting: false,
                    buttonDisabled: false,
                })
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.setState({
                    isRejecting: false,
                    buttonDisabled: false,
                })
            })
        this.forceUpdate();
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';
        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        this.setState({ order, orderBy });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render() {

        const { classes } = this.props;
        const { data, order, orderBy, rowsPerPage, page, isAccepting, isRejecting, isTableLoading, buttonDisabled } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

        return (
            <Paper className={`${classes.root} tableHeader`}>
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                        />
                        {
                            isTableLoading ?
                                <TableBody>
                                    <TableRow>
                                        <TableCell style={{ position: 'absolute', left: '50%' }}>
                                            <CircularProgress className="preloaderCircleHalf" />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                :
                                <TableBody>
                                    {
                                        (isAccepting || isRejecting) &&
                                        <TableRow>
                                            <TableCell colSpan="6" style={{ textAlign: 'center' }}>
                                                <CircularProgress style={{ color: '#606060' }} />
                                            </TableCell>
                                        </TableRow>
                                    }
                                    {data
                                        // .sort(getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map(n => {
                                            return (
                                                <TableRow
                                                    hover
                                                    tabIndex={-1}
                                                    key={n.id}
                                                >
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.userId}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.name}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.userRole}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.email}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.ein === null ? "-" : n.ein}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.license_no === null ? "-" : n.license_no}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.contactNo}</div></TableCell>
                                                    <TableCell className={classes.tdWidth}><div className={classes.cellWidth}>{n.address.address}, {n.address.state}, {n.address.zipcode}</div></TableCell>
                                                    <TableCell className={classes.fixedTd}>
                                                        <div style={{ width: '226px' }}>
                                                            <button className="formApproved" onClick={() => this.acceptUser(n.userId)} disabled={buttonDisabled}>
                                                                <DoneIcon />
                                                                <span>Accept</span>
                                                            </button>
                                                            <button className="formReject" onClick={() => this.rejectUser(n.userId)} disabled={buttonDisabled}>
                                                                <span>Reject</span>
                                                            </button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 49 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                        }
                    </Table>
                </div>
                <TablePagination
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
}

UsersPendingTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UsersPendingTable);



// WEBPACK FOOTER //
// ./src/pages/Users/UsersPendingTable.js